import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueSelfHelpModel } from '../../model/issue-selfhelp.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueService } from '../../service/issue.service';
@Component({
  selector: 'self-help',
  templateUrl:
    'console/app-js/modules/issue/components/self-help-dialog/self-help.component.html'
})
export class SelfHelpComponent extends APIOperableComponent
  implements OnChanges {
  protected isActive: boolean;
  private isEdited: boolean;
  protected clicked: Boolean = false;
  protected activeStatus: String;
  protected issueSelfHelpModel: IssueSelfHelpModel = new IssueSelfHelpModel();
  public index: Number = 0;
  public cnt: number;
  protected selectedQuestion: number;
  protected flagAddSelfHelpButton: Boolean = false;
  protected formElementChoices: IssueSelfHelpModel;
  protected issueSelfHelpModeltext: string;
  @Input('opened') opened = false;
  @Input('selfHelpIssueModel') selfHelpIssueModel: IssueSelfHelpModel;
  @Input('hasSelfHelp') hasSelfHelp = false;
  @Output() closed = new EventEmitter<any>();
  @ViewChild('templateForm', { static: false }) templateForm: NgForm;
  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private issueService: IssueService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnChanges(): void {
    if (!this.clicked && this.opened) {
      this.cnt = 1;
      this.issueSelfHelpModel = this.selfHelpIssueModel;
      this.selectedQuestion = -1;
      this.isActive =
        this.issueSelfHelpModel.elements.filter(
          element => element.isActive === true
        ).length !== 0
          ? this.issueSelfHelpModel.isActive
          : false;
      this.activeStatus = this.isActive ? 'Active' : 'Inactive';
      this.setAddButtonFlag();
    }
  }
  /**
   * close the popup.
   */
  public close(): void {
    this.closed.emit(this.isEdited);
    this.clicked = false;
    this.opened = false;
    this.isEdited = false;
  }
  public open(): void {
    this.opened = true;
  }

  /**
   * save edited issue.
   */

  onSave(): void {
    this.clicked = true;
    if (this.templateForm.valid && this.cnt === 1) {
      this.cnt++;
      this.startProgress();
      let tempUpsertForm = JSON.parse(JSON.stringify(this.issueSelfHelpModel));
      delete tempUpsertForm.issueName;
      tempUpsertForm.elements.forEach(element => {
        element.id = element.id.toString().includes('CUSTOM_ID')
          ? null
          : element.id;
      });
      tempUpsertForm.isActive = this.isActive;
      this.issueService
        .refreshIssueMetaData(tempUpsertForm.issueId)
        .subscribe();
      this.issueService.updateSelfHelp(tempUpsertForm).subscribe(
        result => {
          this.finishProgress();
          this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
          this.isEdited = true;
          this.close();
        },
        err => {
          this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          this.finishProgress();
        }
      );
      this.finishProgress();
    }
  }

  /**
   * add new item
   */
  onAddItem(): void {
    if (this.issueSelfHelpModel.elements.length === 0) {
      this.issueSelfHelpModel.isActive = true;
      this.issueSelfHelpModel.id = null;
    }
    let randNum = Math.floor(Math.random() * 600) + 1;
    let orderIndex = this.issueSelfHelpModel.elements.push({
      id: 'CUSTOM_ID' + randNum,
      text: '',
      elementType: 'Label',
      isActive: true
    });
    this.issueSelfHelpModel.elements[orderIndex - 1].orderIndex = orderIndex;
    this.setAddButtonFlag();
  }
  /**
   * edit existing selfhelp items
   */
  onToggle(index) {
    if (this.templateForm.valid) {
      this.selectedQuestion = index;
      this.index = index;
    }
  }
  /**
   * onChange switch value.
   */
  valueChanged(value: Boolean): void {
    if (value) {
      this.isActive = false;
      this.activeStatus = 'Inactive';
    } else {
      this.isActive = true;
      this.activeStatus = 'Active';
    }
  }
  /**
   * Method check for whitespeace
   */
  public checkWhiteSpace(text: string, control: any): void {
    if (text && text.trim() === '') {
      control.setErrors({ required: true });
    }
  }
  /**
   * control the button active or inactive for add items and editing selfhelp items
   */
  setAddButtonFlag() {
    if (
      this.issueSelfHelpModel.elements.filter(d => d.isActive === true)
        .length <= 4
    ) {
      this.flagAddSelfHelpButton = true;
    } else {
      this.flagAddSelfHelpButton = false;
    }
  }

  openDeleteDialog(event, self: IssueSelfHelpModel) {
    event.stopPropagation();
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            IssueUIMessages.DELETE_SELFHELP_TITLE,
            IssueUIMessages.DELETE_SELFHELP_CONFIRMATION
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.issueSelfHelpModel.elements.forEach(selfhelp => {
            if (selfhelp.id === self.id) {
              selfhelp.isActive = false;
            }
          });
          this.setAddButtonFlag();
        }
      });
  }
}
